import { formatFullAddressOld } from 'utils/address';
import { FIELDS, RADIO_VALUES } from 'screens/Panel/screens/User/screens/Edit/Edit.types';
import {
  UserDataForSave,
  UserDataForView,
  UserDataFromApi,
} from 'screens/Panel/screens/User/screens/Edit/mapper/types';

export const mapApiDataForView = (data: UserDataFromApi): UserDataForView => {
  const fullAddress = {
    houseNumber: data.house_number,
    addressLine1: data.street_line_1,
    addressLine2: data.street_line_2,
    city: data.city,
    postcode: data.post_code,
    county: data.county,
  };

  return {
    [FIELDS.FULL_NAME]: concatFullName(data.first_name, data.last_name),
    [FIELDS.FULL_ADDRESS]: formatFullAddressOld(fullAddress),
    [FIELDS.COMPANY]: data.company.name,
    [FIELDS.FCA_NUMBER]: data.company.fca_number,
    [FIELDS.FCA_STATUS]: mapBooleanToStatus(data.fca ? data.fca.is_active : false),
    [FIELDS.LMC_STATUS]: mapBooleanToStatus(!!data.is_active),
    [FIELDS.POSTCODE]: data.post_code,
    [FIELDS.ADDRESS_LINE_1]: data.street_line_1,
    [FIELDS.ADDRESS_LINE_2]: data.street_line_2,
    [FIELDS.HOUSE_NUMBER]: data.house_number,
    [FIELDS.CITY]: data.city,
    [FIELDS.COUNTY]: data.county,
    [FIELDS.PHONE]: data.phone,
    [FIELDS.EMAIL_ADDRESS]: data.email,
  };
};

export const mapFormDataForSave = (data: UserDataForView): UserDataForSave => {
  return {
    city: data[FIELDS.CITY],
    county: data[FIELDS.COUNTY],
    email: data[FIELDS.EMAIL_ADDRESS],
    house_number: data[FIELDS.HOUSE_NUMBER],
    phone: data[FIELDS.PHONE],
    post_code: data[FIELDS.POSTCODE],
    street_line_1: data[FIELDS.ADDRESS_LINE_1],
    street_line_2: data[FIELDS.ADDRESS_LINE_2],
  };
};

const concatFullName = (firstName: string, lastName: string) => `${firstName} ${lastName}`;

const mapBooleanToStatus = (value: boolean): RADIO_VALUES => (value ? RADIO_VALUES.ACTIVE : RADIO_VALUES.INACTIVE);
